export default "__VITE_ASSET__DGHwi65Y__"